/* ============================================================
   TAIBI — CARRELLO, «COMPLETA LA LINEA»

   ⚠️ QUESTO È L'UNICO JAVASCRIPT DEL BLOCCO, E SERVE PER NON MENTIRE.
   Tutto il resto è Liquid: lo scambio e le aggiunte sono due `form` normali
   che ricaricano la pagina, quindi il blocco si ridisegna da solo.

   Il caso che resta scoperto è un altro: quando il cliente cambia una
   quantità con i ± di Dawn, o toglie una riga con la ✕, la pagina NON si
   ricarica. `assets/cart.js` ridisegna solo quattro sezioni
   (`getSectionsToRender()`, riga 144) e questa non è fra quelle: il blocco
   resterebbe a proporre lo scambio per uno shampoo che non c'è più.

   ✅ Però `cart.js` pubblica `cartUpdate` (riga 256). Bastano queste righe
   in ascolto perché il blocco si rilegga da solo.

   ⚠️ `subscribe` e `PUB_SUB_EVENTS` arrivano da `pubsub.js` e `constants.js`,
   caricati in `theme.liquid` alle righe 52-53 con `defer`. Se un giorno non
   ci fossero, qui si esce in silenzio: il blocco resta com'è invece di
   spaccare la pagina.
   ============================================================ */

(function () {
  'use strict';

  var SEGNO = '[data-taibi-completa]';

  function rileggi(idSezione) {
    var indirizzo = window.location.pathname + '?section_id=' + idSezione;

    fetch(indirizzo)
      .then(function (risposta) {
        return risposta.text();
      })
      .then(function (html) {
        var vecchio = document.querySelector(SEGNO);
        if (!vecchio) return;

        var nuovo = new DOMParser().parseFromString(html, 'text/html').querySelector(SEGNO);

        /* Nessun blocco nella risposta = non c'è più niente da proporre
           (carrello svuotato, oppure il cliente ha già preso tutto). Si
           svuota, non si lascia il vecchio contenuto. */
        vecchio.innerHTML = nuovo ? nuovo.innerHTML : '';
      })
      .catch(function () {
        /* Rete caduta: si tiene quello che c'è. Un blocco vecchio di
           qualche secondo è meno peggio di un blocco sparito. */
      });
  }

  function accendi() {
    var radice = document.querySelector(SEGNO);
    if (!radice) return;
    if (radice.getAttribute('data-acceso') === '1') return;

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    var idSezione = radice.getAttribute('data-sezione');
    if (!idSezione) return;

    radice.setAttribute('data-acceso', '1');

    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      rileggi(idSezione);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', accendi);
  } else {
    accendi();
  }

  /* Anteprima dell'editor: la sezione viene rimontata, e l'ascolto va rifatto. */
  document.addEventListener('shopify:section:load', function (evento) {
    if (evento.target && evento.target.querySelector(SEGNO)) accendi();
  });
})();

/* ═══ LA BOLLA DELLA CHAT NON STA SUI NOSTRI BOTTONI ═══════════════════
   Misurato in vetrina il 26 agosto 2026, sul carrello vero e non sul banco:
   `#carthike-chat-button-container` è `fixed` in basso a destra con
   `z-index: 1000000` e finisce **sopra «Passa al kit»**. È lo stesso difetto
   già trovato e risolto sulla scheda prodotto il 23 agosto.

   ⚠️ È LA STESSA LOGICA CHE STA IN `taibi-prodotto.js`, RIGA ~208. Vive in
   due posti perché quel file è tutto scheda-prodotto e caricarlo sul
   carrello per prendere quaranta righe costerebbe più di quello che
   risolve. **Se serve una terza volta, va estratta in un file suo.**

   ⚠️ SI SPEGNE CON `opacity` E `pointer-events`, mai con `display: none`:
   è il nodo di un'app di terze parti, togliergli la scatola può romperne il
   JS. Così resta impaginato e smette solo di prendere il dito.
   ⚠️ LA BOLLA NON C'È ANCORA quando questo script parte: l'app la inietta in
   differita. Per questo si cerca a ogni controllo e si guarda anche quando
   il `body` cambia figli.
   ⚠️ L'AGGANCIO È L'ID DI UN'APP: se carthike lo cambia, questa cosa smette
   di funzionare in silenzio. Il segno che è successo è la bolla di nuovo
   sopra il bottone. */

(function () {
  'use strict';

  var atteso = false;

  function siToccano(a, b) {
    return !(a.right <= b.left || a.left >= b.right || a.bottom <= b.top || a.top >= b.bottom);
  }

  function controlla() {
    atteso = false;
    var bolla = document.getElementById('carthike-chat-button-container');
    if (!bolla) return;
    var b = bolla.getBoundingClientRect();
    if (!b.width || !b.height) return;

    var coperto = false;
    /* ⚠️ Si rilegge dal documento a ogni giro: dopo che il blocco si è
       riscritto da solo, i nodi di prima sono fuori dall'albero e i loro
       rettangoli sono tutti zero.

       🔴 NON SOLO I NOSTRI BOTTONI — misurato in vetrina il 26 agosto.
       Guardava solo il blocco «completa la linea», e intanto la bolla stava
       **sopra il bottone Google Pay**: 61 × 15 px, un quinto della sua
       superficie, e `elementFromPoint` in quell'angolo rispondeva
       `BUTTON.whatsappbutton`. Cioè un dito sul pagamento apriva WhatsApp.
       ⚠️ È PEGGIO del difetto che questo codice era nato a risolvere: là si
       perdeva un suggerimento, qui si perde un pagamento.
       ⚠️ I pagamenti accelerati stanno dentro elementi personalizzati e un
       iframe: si guarda il CONTENITORE, che ha il rettangolo giusto
       (misurato 15-360 × 634-676), non i singoli bottoni.
       ⚠️ E `.compl-fissa`: la barra fissa del telefono sta esattamente
       dove sta la bolla, in basso a destra. Si guarda TUTTA la barra e non
       solo il suo bottone, perché anche il totale coperto è un danno. */
    var comandi = document.querySelectorAll(
      '[data-taibi-completa] [data-taibi-comando], #checkout, .cart__dynamic-checkout-buttons, .compl-fissa'
    );
    for (var i = 0; i < comandi.length; i++) {
      var c = comandi[i].getBoundingClientRect();
      if (!c.width || !c.height) continue;
      if (siToccano(b, c)) {
        coperto = true;
        break;
      }
    }

    bolla.style.transition = 'opacity .18s ease';
    bolla.style.opacity = coperto ? '0' : '';
    bolla.style.pointerEvents = coperto ? 'none' : '';
    bolla.setAttribute('aria-hidden', coperto ? 'true' : 'false');
  }

  function chiedi() {
    if (atteso) return;
    atteso = true;
    window.requestAnimationFrame(controlla);
  }

  /* ⚠️ Niente listener su `scroll` non frenato: si passa da `rAF`, e il conto
     è due `getBoundingClientRect` — non tocca l'impaginazione. */
  window.addEventListener('scroll', chiedi, { passive: true });
  window.addEventListener('resize', chiedi, { passive: true });

  if ('MutationObserver' in window) {
    new MutationObserver(chiedi).observe(document.body, { childList: true });
  }

  chiedi();
})();

/* ═══ «AGGIUNGI» NON SI PREME DUE VOLTE — 21 settembre 2026, notte ═══════
   Scansione UI/UX: i form del blocco ricaricano la pagina, e fra il tocco e
   il ricaricamento il bottone restava vivo. Un doppio tocco = due pezzi.
   Al `submit` il bottone si blocca (`aria-busy` + `disabled`) e il CSS gli
   mette la rotella (`section-carrello-completa.css`, in fondo).
   ⚠️ `disabled` al giro dopo e non subito: l'invio è già partito, ma così
   nessun browser ha modo di annullarlo. Il bottone non ha `name`, quindi
   bloccarlo non toglie niente dai dati spediti.
   ⚠️ Ascolto sul `document`, non sui form: il blocco si riscrive da solo
   (`rileggi`, qui sopra) e i form di prima escono dall'albero.
   ⚠️ `pageshow` con `persisted`: tornando indietro, Safari rimette la
   pagina com'era — col bottone ancora bloccato. */

(function () {
  'use strict';

  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!form || !form.closest || !form.closest('[data-taibi-completa]')) return;
    var bottone = form.querySelector('button[type="submit"]');
    if (!bottone) return;
    if (bottone.getAttribute('aria-busy') === 'true') {
      evento.preventDefault();
      return;
    }
    bottone.setAttribute('aria-busy', 'true');
    window.setTimeout(function () {
      bottone.disabled = true;
    }, 0);
  });

  window.addEventListener('pageshow', function (evento) {
    if (!evento.persisted) return;
    var bloccati = document.querySelectorAll('[data-taibi-completa] button[aria-busy="true"]');
    for (var i = 0; i < bloccati.length; i++) {
      bloccati[i].removeAttribute('aria-busy');
      bloccati[i].disabled = false;
    }
  });
})();
